import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  careerList,
  careerDelete,
} from "../../../store/actions/websiteActions";
import { Popconfirm, message, Empty } from "antd";
import TableWrapper from "../../../components/Tables";
import Pagination from "../../../components/Pagination";

const CareerIndex = () => {
  const [search, setsearch] = useState("");
  let dispatch = useDispatch();
  let history = useHistory();

  useEffect(() => {
    dispatch(careerList(1, search));
    localStorage.removeItem("id_career");
  }, [dispatch]);

  useEffect(() => {
        if (!userInfo || !userInfo.permission) return;
    if (userInfo.user.roles[0].name == "Super Admin") return;
    if (!userInfo.permission.includes("career-read")) window.location.href = process.env.REACT_APP_LINK_REDIRECT + "403";
  }, []);

  const datacareerList = useSelector((state) => state.careerList);
  const { career, listsCareer } = datacareerList;

  const dataLogin = useSelector((state) => state.login);
  let { userInfo } = dataLogin;

  const handleEdit = (id) => {
    localStorage.setItem("id_career", id);
    history.push("/career-edit");
  };
  
  const handleSearch = (e) => {
    e.preventDefault();
    dispatch(careerList(1, search));
  };

  const tableHead = [
    { name: "No" },
    { name: "Type" },
    { name: "Job Position" },
    { name: "Registrion Link" },
    { name: "Status" },
    { name: "Action" },
  ];

  const tableBody = [
    { scope: "row" },
    { render: (item) => item.type },
    { render: (item) => item.title },
    { render: (item) => item.link },
    {
      render: (item) => (
        <div align="center">
          <span
            className={` badge ${item.active ? "badge-success" : "badge-danger"}`}
          >
            {item.active ? "active" : "deactive"}
          </span>
        </div>
      ),
    },
    {
      render: (item) => (
        <div align="center">
          {userInfo.permission.find((e) => e === "career-edit") ? (
            <button
              onClick={() => handleEdit(item.id)}
              className="btn btn-warning btn-sm"
            >
              <i className="fa fa-pencil"></i> Edit{" "}
            </button>
          ) : null}
          {userInfo.permission.find((e) => e === "career-delete") ? (
            <Popconfirm
              title="Are you sure to delete this parent?"
              onConfirm={() =>
                dispatch(careerDelete(item.id)).then(() =>
                  dispatch(careerList(1, search))
                )
              }
              onCancel={() => message.info("Canceled!")}
              okText="Yes"
              cancelText="No"
            >
              <button className="btn btn-danger btn-sm">
                <i className="fa fa-trash-o"></i> Delete{" "}
              </button>
            </Popconfirm>
          ) : null}
        </div>
      ),
    },
  ];

  return (
    <div className="">
      <div className="page-title">
        <div className="title_left">
          <h3>Career</h3>
        </div>
      </div>
      <div className="clearfix"></div>
      <br />
      <div className="row">
        <div className="col-md-12 col-sm-12 col-xs-12">
          <div className="x_panel">
            <div className="x_title">
              <div className="row">
                <div className="col-md-6 col-sm-12 col-xs-12">
                  {userInfo.permission.find((e) => e === "career-create") ? (
                    <Link to={"/career-create"} className="btn btn-info btn-sm">
                      Create
                    </Link>
                  ) : null}
                </div>
                <div className="col-md-6 col-sm-12 col-xs-12 form-group has-feedback">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search By Name"
                    style={{ float: "right", width: "50%", textOverflow: "ellipsis", paddingRight: "33px"  }}
                    onChange={(e) => setsearch(e.target.value)}
                  />
                  <button
                    className="fa fa-search form-control-feedback right btn btn-link"
                    style={{
                      height: "100%",
                      margin: "auto",
                      textDecoration: "none",
                    }}
                    aria-hidden="true"
                    onClick={(e) => handleSearch(e)}
                  ></button>
                </div>
              </div>
              <div className="clearfix"></div>
            </div>

            <div className="x_content overflow-auto">
              <TableWrapper
                datas={listsCareer}
                tableHead={tableHead}
                tableBody={tableBody}
              />
              <Pagination
                datas={career}
                listsData={careerList}
                search={search}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CareerIndex;
